import Highcharts from "highcharts"
import HighchartsReact from "highcharts-react-official"
import { useAppDispatch, useAppSelector } from "../../util/hooks"
import {
  timePeriodOptionsMaintenance,
  weekAndMonthMapper,
} from "../../util/StaticData"
import SingleSelection from "../../components/Filters/SingleSelection"
import { useEffect } from "react"
import { chartViewChange, maintenanceChartAsync } from "./MaintenanceSlice"
import { Box } from "@mui/material"

const ExecutionHistoryChart = () => {
  const dispatch = useAppDispatch()
  const view = useAppSelector((store) => store.maintenance.chartView)
  useEffect(() => {
    dispatch(maintenanceChartAsync())
  }, [view, dispatch])
  const chartData = useAppSelector((store) => store.maintenance.chartData)
  const options = {
    chart: {
      type: "spline",
    },
    title: {
      text: "",
    },
    subtitle: {},
    credits: {
      enabled: false,
    },
    plotOptions: {
      series: {
        dataLabels: {
          enabled: true,
          verticalAlign: "bottom",
          align: "left",
        },
      },
    },
    xAxis: {
      categories: structuredClone(chartData.categories),
      gridLineWidth: 1,
      title: {
        text: weekAndMonthMapper[view],
      },
    },
    yAxis: {
      title: {
        text: "Pipeline Count",
      },
      gridLineWidth: 1,
    },
    tooltip: {
      formatter: formatter,
    },
    series: [
      {
        name: "Pipelines Executed",
        data: structuredClone(chartData.totalCount),
        color: "#25d4cf",
        marker: {
          symbol: "circle",
        },
      },
    ],
  }
  function formatter(this: any): string {
    return `
    <h1>Total Count : ${this.y}  </h1>
    <br/>
    <p>Pass: <span id="passCount"> ${this.point.custom.passed}</span></p>
    <br/>
    <p>Fail: <span id="failCount">${this.point.custom.failed}</span></p>
    `
  }
  return (
    <Box sx={{ height: "100%" }}>
      <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
        <SingleSelection
          minWidth={80}
          maxWidth={100}
          changeFunc={(value: string) => dispatch(chartViewChange(value))}
          filterValue={view}
          options={timePeriodOptionsMaintenance}
          isSearchable={true}
          label="View By"
          minHeight={29}
          isDisabled={false}
          showLabel={true}
        />
      </Box>
      <>
        <HighchartsReact
          highcharts={Highcharts}
          options={options}
          constructorType={"chart"}
        />
      </>
    </Box>
  )
}

export default ExecutionHistoryChart
